import { Component, OnInit, ViewChild } from '@angular/core';
import { Regex } from '../../../core/constants/app.constant';
import { OktaService } from '../okta.service';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { CacheConstant } from '../../../core/constants/app.constant';
import { HttpError } from '../../../shared/models/http-error';
import { OktaConstant } from '../okta.constant';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';

@Component({
  selector: 'par-expired-password',
  templateUrl: './expired-password.component.html',
  styleUrls: ['./expired-password.component.scss']
})
export class ExpiredPasswordComponent implements OnInit {
  /***************Properties***************/
  envProperties =this.cache.get(CacheConstant.Env_Properties);
  websiteName: string = this.envProperties.theme;
  stateToken: string;
  userId: any;
  validation: any = {
    passwordRegex: Regex.Password
  };
  change: any = {
    newPassword: '',
    confirmPassword: ''
  };
  messages: any = {
    passwordHint: OktaConstant.Messages.ChangePasswordHintMessage
  };
  serverErrors: any = {
    errorMessage: null
  };
  /***************Properties***************/

  /***************Constructor***************/

  constructor(private oktaService: OktaService, private cache: AppCacheService) {}

  ngOnInit() {
    this.userId = AppUtilService.cache.get(CacheConstant.User_Id);
    this.getStateToken();
  }

  /***************Constructor***************/

  /***************Component Methods***************/

  onChangePassword() {
    this.serverErrors.errorMessage = '';
    const resetAuthObj = {
      newPassword: this.change.newPassword,
      oktaUserId: this.userId,
      source: 'PASSWORD_RESET',
      stateToken: this.stateToken,
      buId: this.envProperties.buId
    };

    this.oktaService
      .resetPassword(resetAuthObj)
      .subscribe((response: any) => {
        if (response && response.hasError) {
          this.serverErrors.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        } else {
          AppUtilService.message.success(
            OktaConstant.Messages.ResetPasswordSuccessMesssage
          );
          AppUtilService.redirectToHome();
        }
      });
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private getStateToken() {
    this.oktaService.getVerifyToken(this.userId).subscribe((response: any) => {
      if (!response.hasError) {
        this.verifyToken(response.recoveryToken);
      }
    });
  }

  private verifyToken(recoveryToken) {
    this.oktaService.verifyToken(recoveryToken).subscribe((response: any) => {
      if (!response.hasError) {
        this.stateToken = response.stateToken;
      }
    });
  }

  /***************Private Methods***************/
}
